// Angular
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * A custom validator to check that the control value does not contain any numbers.
 * 
 * @returns A hasNumbers ValidationError key value pair if invalid, otheriwse null. 
 */
export function noNumericsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // Cast the AbstractControl into the actual type we know is being used.
    const controlFC = control as FormControl<string>;

    // If the control value is empty return nuyll because there's no error.
    if (!controlFC.value) { 
      return null; 
    }

    // Check if the control value contains any numbers.
    const hasNumbers = /\d/.test(controlFC.value);

    // If the control value contains numbers set the validation error.
    if (hasNumbers) {
      return { hasNumbers: true };
    }
    
    // Otherwise the control value does not contain numbers so return null.
    return null;
  };
}